<template>  
    <logoCom />    
    <router-view />    
</template>

<style lang="scss">
    #app {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }

</style>
<script>
    import {central_data} from '@/lib/vendor/eve/central-data';
    import U from '@/lib/vendor/eve/lib-utils';
    import logoCom from './components/logo-com';
    export default{
        name: 'app-main',
        data: function () {
            return{
                show_menu: false,
                isAdminUser: false
            };
        },
        components: {
            logoCom: logoCom
        },
        methods: {
            check_login: function () {
                if (U.IntMoreOr(central_data().jwtMonitor.get_payload('id'), 0, null)) {
                    this.$data.show_menu = true;
                    this.$data.isAdminUser = central_data().jwtMonitor.userRoleIs('admin');
                } else {
                    this.$data.show_menu = false;
                    this.$data.isAdminUser = false;
                }
            },
            logout: function () {
                central_data().jwtMonitor.clear_token();
                location.reload(true);
            }
        },
        created: function () {
            central_data().jwtMonitor.on(this, this.check_login);
        },
        unmounted: function () {
            central_data().jwtMonitor.off(this, this.check_login);
        },
        mounted: function () {
            this.check_login();
        }

    }
</script>